"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 17 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of Supply
 * @author RV
 */


var SupplyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplyConverter, _DataObjectConverter_);

  function SupplyConverter() {
    _classCallCheck(this, SupplyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplyConverter).apply(this, arguments));
  }

  return SupplyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplyConverter = SupplyConverter;